import React from 'react';
import { useHistory } from 'react-router-dom';
import i18n from '../../../i18n';
import { useSelector } from 'react-redux';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Formik } from 'formik';

import { useRouterParam } from 'core/router/router';
import { useAction, useActionDispatchOnMount } from 'core/store/store';

import { isUIEnabledSelector } from 'state/app/selectors';
import { orderCurrentItemSelector, orderErrorMessageSelector } from 'state/order/selector';
import { makeOrderFetchItemRequestAction, makeOrderSendForApprovalAction } from 'state/order/actions';

import { Dialog } from 'components/Dialog/Dialog';
import { LargeButton } from 'components/LargeButton/LargeButton';
import { OrdersTableEdit } from 'components/OrderCard/OrdersTableEdit';
import { OrderCustomerPhone } from './OrderCustomerPhone';
import { FormErrorMessage } from 'components/FormErrorMessage/FormErrorMessage';

import { RoutePath } from 'RoutePath';
import { UserRole } from 'types';

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
    },
    orderDetails: {
        flex: 1,
    },
    actions: {
        display: 'flex',
        flexGrow: 0,
        flexBasis: 'auto',
        padding: theme.spacing(2),
    },
    action: {
        flex: 1,
    },
    actionSpace: {
        flexBasis: theme.spacing(2),
    },
}));

export const OrdersNewEditDialog = () => {
    const classes = useStyles();
    const history = useHistory();
    const { t } = i18n.useTranslation();
    const id = useRouterParam('orderId');
    useActionDispatchOnMount(true, makeOrderFetchItemRequestAction, id);
    const action = useAction();
    const order = useSelector(orderCurrentItemSelector);
    const isUIEnabled = useSelector(isUIEnabledSelector);
    const initialValues = order
        ? order.orderedProducts.reduce((acc, p) => ({ ...acc, [p.productId]: p.quantity }), {})
        : {};
    const error = useSelector(orderErrorMessageSelector);
    return (
        <Dialog fullHeight={true} title={t('orders:dialog.title')} onClose={() => history.push(RoutePath.ORDERS_NEW)}>
            {order && (
                <Formik
                    onSubmit={data => {
                        action(makeOrderSendForApprovalAction, data);
                    }}
                    initialValues={initialValues}
                >
                    {({ submitForm, values, handleChange, setFieldValue }) => (
                        <div className={classes.container}>
                            <Box m={2}>
                                <OrderCustomerPhone
                                    userRole={UserRole.CUSTOMER}
                                    phoneNumber={(order as any)?.username}
                                />
                            </Box>
                            <div className={classes.orderDetails}>
                                {order && (
                                    <OrdersTableEdit
                                        orderResponse={order}
                                        values={values}
                                        handleChange={handleChange}
                                        setFieldValue={setFieldValue}
                                    />
                                )}
                            </div>
                            {error && (
                                <Box m={2}>
                                    <FormErrorMessage error={error} />
                                </Box>
                            )}
                            <div className={classes.actions}>
                                <div className={classes.action}>
                                    <LargeButton
                                        disabled={!isUIEnabled}
                                        onClick={() => {
                                            // dispatch(makeOrderAcceptAction(id));
                                            submitForm().then();
                                        }}
                                    >
                                        {t('orders:dialog.sendForApproval')}
                                    </LargeButton>
                                </div>
                            </div>
                        </div>
                    )}
                </Formik>
            )}
        </Dialog>
    );
};
